<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H16V16H0V0ZM1.33333 1.5H14.6667V3H1.33333V1.5ZM14.6667 4.5V14.5H1.33333V4.5H14.6667Z" fill="currentColor" />
</svg>
